export const KEY_ESC = 27
export const KEY_UP = 38
export const KEY_DOWN = 40
export const KEY_ENTER = 13
